import React from 'react';

import { AddSuppliers } from '../../Onboarding/add-suppliers';

import { useStyles } from './style';

export const AddSupplierTab: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.title}>Lets add your suppliers</div>
      <div className={classes.subtitle}>
        Search for your suppliers or if they aren’t there invite them. <br /> Its free for them too.
      </div>
      <AddSuppliers category={null} onboarded={true} />
    </div>
  );
};
